var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout',{attrs:{"mainClass":null,"containerized":false}},[_c('div',{staticClass:"w-100"},[_c('iframe',{staticClass:"w-100 h-100 border-0",attrs:{"src":_vm.iframeUrl,"id":"edubookersIframe","allowtransparency":"true"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }